// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"23c9a469","455":"7cbd2a15","977":"f64da749"}[chunkId] + ".chunk.js";
};